import { coreFetch, CoreApiError } from '../core/coreHttp';

export interface UserActionNotification {
  id: string;
  message: string;
  action?: string;
  createdAt?: string;
}

interface CoreNotification {
  id: number;
  message: string;
  action: string | null;
  created_at: string;
}

const toUserActionNotification = (doc: CoreNotification): UserActionNotification => ({
  id: String(doc.id),
  message: doc.message,
  action: doc.action || undefined,
  createdAt: doc.created_at,
});

export const notificationsApi = {
  async list(): Promise<UserActionNotification[]> {
    const docs = await coreFetch<CoreNotification[]>('/notifications');
    return docs.map(toUserActionNotification);
  },

  async create(message: string, action?: string): Promise<{ id: number }> {
    return coreFetch<{ id: number }>('/notifications', {
      method: 'POST',
      body: action ? { message, action } : { message },
    });
  },

  async remove(id: string | number): Promise<void> {
    try {
      await coreFetch<void>(`/notifications/${id}`, { method: 'DELETE' });
    } catch (error) {
      // 404 means "not yours or doesn't exist" — indistinguishable by design,
      // and either way the notification is already gone from the user's view.
      if (error instanceof CoreApiError && error.status === 404) return;
      throw error;
    }
  },
};
